define('TescoMobile_Eecc/js/accessible-format-form',['uiComponent', 'jquery', 'underscore', 'mage/url', 'TescoMobile_Checkout/js/action/find-address', './action/save-form', 'mage/translate', 'Magento_ReCaptchaFrontendUi/js/reCaptcha', 'Magento_ReCaptchaFrontendUi/js/registry', 'jquery-ui-modules/widget', 'mage/validation'], function (Component, $, _, urlBuilder, findAddressAction, saveFormAction, $t, reCaptcha, registry) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Eecc/accessible-format-form',
      lookupActive: true,
      processStart: null,
      processStop: null,
      bindSubmit: true,
      method: 'rest',
      version: 'V1',
      serviceUrl: ':method/:storeCode/:version',
      accordionItems: [],
      hasAddresses: false,
      onlyOneAddress: false,
      postcodeNotValid: false,
      addresses: [],
      caption: '',
      options: [],
      value: '',
      addressline1: '',
      addressline2: '',
      addressline3: '',
      town: '',
      buildRefValue: '',
      postcodeValue: '',
      countryId: 'GB',
      validatedFieldsArr: [],
      sbmBtn: null,
      formKey: $.mage.cookies.get('form_key'),
      errorMessage: '',
      isReCaptchaEnabled: false
    },
    initialize: function () {
      this._super();
      this.value.subscribe(this.updateAddress.bind(this));
    },
    initObservable: function () {
      this._super();
      this.initialOptions = this.options;
      return this._super().observe(['lookupActive', 'city', 'addressLine1', 'addressLine2', 'ptcAbsCode', 'addresses', 'mappedAddresses', 'hasAddresses', 'onlyOneAddress', 'options', 'caption', 'value', 'buildRefValue', 'postcodeValue', 'addressline1', 'addressline2', 'addressline3', 'town', 'postcodeNotValid', 'errorMessage']).setOptions(this.options());
    },
    getContractFormatArray: function () {
      return Object.values(this.contractFormatArray);
    },
    setElements: function () {
      this.successMsgText = 'Email sent';
      this.failMsgText = 'Something went wrong, please try again later';
      this.validatedFieldsArr = document.querySelectorAll('#tm-accessible-format-form input[type="text"], #tm-accessible-format-form #contract-format');
      this.sbmBtn = document.querySelector('#tm-accessible-format-form button');
      this.isSubmitActive(this.validatedFieldsArr, this.sbmBtn);
    },
    getTitles: function () {
      return this.customerTitles;
    },
    replaceAddresses: function () {
      let self = this,
        postCode = document.querySelector('aside [name="postcode-lookup"]'),
        buildRef = document.querySelector('aside [name="buildRef"]');
      if (!!$.validator.validateSingleElement(postCode) && !!$.validator.validateSingleElement(buildRef)) {
        findAddressAction(self.countryId, self.postcodeValue(), self.buildRefValue()).done(function (addresses) {
          self.setAddresses(addresses);
          self.fieldsValidation(self.validatedFieldsArr, self.sbmBtn);
        });
      }
    },
    findAddress: function () {
      let self = this,
        postCode = document.querySelector('aside [name="postcode-lookup"]'),
        buildRef = document.querySelector('aside [name="buildRef"]');
      if (!!$.validator.validateSingleElement(postCode) && !!$.validator.validateSingleElement(buildRef)) {
        $('body').loader('show');
        findAddressAction(self.countryId, self.postcodeValue(), self.buildRefValue()).done(function (addresses) {
          self.setAddresses(addresses);
          self.fieldsValidation(self.validatedFieldsArr, self.sbmBtn);
        }).always(function () {
          $('body').loader('hide');
        });
      }
    },
    indexOptions: function (data, result) {
      let value,
        self = this;
      result = result || {};
      data.forEach(function (item) {
        value = item.value;
        if (Array.isArray(value)) {
          self.indexOptions(value, result);
        } else {
          result[value] = item;
        }
      });
      return result;
    },
    parseOptions: function (nodes, captionValue) {
      let caption, value;
      nodes = _.map(nodes, function (node) {
        value = node.value;
        if (value === null || value === captionValue) {
          if (_.isUndefined(caption)) {
            caption = node.label;
          }
        } else {
          return node;
        }
      });
      return {
        options: _.compact(nodes),
        caption: _.isString(caption) ? caption : false
      };
    },
    setOptions: function (data) {
      let captionValue = this.captionValue || '',
        result = this.parseOptions(data, captionValue),
        isVisible;
      this.indexedOptions = this.indexOptions(result.options);
      this.options(result.options);
      if (!this.caption()) {
        this.caption(result.caption);
      }
      if (this.customEntry) {
        isVisible = !!result.options.length;
        this.setVisible(isVisible);
        this.toggleInput(!isVisible);
      }
      return this;
    },
    updateAddress: function (value) {
      const address = this.addresses()[value] || {};
      this.addressline1(address.address_line1 || '');
      this.addressline2(address.address_line2 || '');
      this.addressline3(address.building_identifier || '');
      this.town(address.town || '');
      this.postcodeValue(address.postcode || '');
    },
    setAddresses: function (addresses) {
      if (!addresses) {
        return;
      }
      if (addresses.length === 0 || addresses[0].ptc_abs_code) {
        this.addresses(addresses);
        this.hasAddresses(addresses.length > 0);
        this.onlyOneAddress(addresses.length === 1);
        this.setOptions(addresses.map((address, index) => ({
          value: index,
          label: address.building_identifier + ',' + address.address_line1 + ',' + address.postcode
        })));
        this.postcodeNotValid(false);
      } else {
        this.postcodeNotValid(true);
        this.addresses([]);
      }
    },
    getFormatedAddressItem: function () {
      const address = this.addresses()[0] || {};
      let formatedAddress = '';
      formatedAddress += address.building_identifier ? address.building_identifier + ', ' : '';
      formatedAddress += address.address_line1 ? address.address_line1 + ', ' : '';
      formatedAddress += address.address_line2 ? address.address_line2 + ', ' : '';
      formatedAddress += address.postcode ? address.postcode : '';
      return formatedAddress;
    },
    getSubmitUrl: function () {
      return urlBuilder.build('eecc/accessibleFormat/requestAjax');
    },
    isSubmitActive: function (arr, btn) {
      let self = this;
      arr.forEach(element => {
        element.addEventListener('change', function () {
          self.fieldsValidation(arr, btn);
        });
      });
    },
    fieldsValidation: function (arr, btn) {
      const validInputs = Array.from(arr).filter(input => input.value == "");
      validInputs.length == 0 && this.hasAddresses() ? btn.disabled = false : btn.disabled = true;
    },
    ajaxFormSent: function () {
      let self = this;
      if (this.isReCaptchaEnabled) {
        let captchaList = registry.captchaList();
        grecaptcha.execute(captchaList.shift());
      }
      saveFormAction(this.formId).done(function (response) {
        if (response.is_successful) {
          $(this.formWrapper).addClass('ajax-success');
        } else {
          self.errorMessage(response.message);
          $(this.formWrapper).addClass('ajax-fail');
        }
      }.bind(this)).fail(function () {
        self.errorMessage($t('Something went wrong, please try again later.'));
        $(this.formWrapper).addClass('ajax-fail');
      }.bind(this));
    }
  });
});

